module.exports = __webpack_public_path__ + "static/img/event1.252cb93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popup/concierge/20250613/event1.png
// module id = PxGs
// module chunks = 0